<template>
  <section>
    <form action v-on:submit.prevent="createFolder">
      <div class="modal-card">
        <header class="modal-card-head">
          <p>Crear Carpeta</p>
        </header>
        <section class="modal-card-body">
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
          <b-message type="is-warning" v-if="folder_id">
            Se está creando una carpeta en <b>{{parentFolder.name}}</b>
          </b-message>
          <b-field label="Nombre de la carpeta" :label-position="'on-border'">
            <b-input v-model="folder.name" required></b-input>
          </b-field>
          <b-field label="Descripción" :label-position="'on-border'">
            <b-input
              v-model="folder.description"
              type="textarea"
              required
            ></b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="$parent.close()">
            Cerrar
          </button>
          <button class="button is-primary" type="submit">Guardar</button>
        </footer>
      </div>
    </form>
  </section>
</template>
<script>
// import { postDirectory } from "../../../services/directory";
import { DirectoryService } from '../../../services/models/directory';

export default {
  props:['chargeListDirectory', 'folder_id'],
  data() {
    return {
      folder: {
        name: "",
        description: "",
        cellar_id:this.$route.params.id,
        dependency_id: this.folder_id
      },
      parentFolder: {
        name: ""
      },
      isLoading: false,
    };
  },
  async mounted() {
    if (this.folder_id) {
      this.isLoading = true;
      const {data : folder} = await DirectoryService.getById(this.folder_id);
      this.isLoading = false;
      this.parentFolder = folder;
    }
  },
  methods: {
    async createFolder() {
      this.isLoading = true;
      let data = {
        ...this.folder,
      };
      await DirectoryService.create(data);
      // await postDirectory(this.$http, data);
      this.isLoading = true;
      this.$buefy.notification.open({
        message: "Carpeta Creada!",
        type: "is-success",
      });
      this.chargeListDirectory();
      this.$parent.close();
    },
  },
};
</script>